// extracted by mini-css-extract-plugin
module.exports = {"categoryList":"category-list_categoryList__7c7T2","title":"category-list_title__oJsOY","list":"category-list_list__tfwrH","item":"category-list_item__4l8PR"};